import { SET_REPORT_GRAPH_STATE } from './actionTypes';

const setReportGraphState = reportGraphState => ({
    type: SET_REPORT_GRAPH_STATE,
    payload: reportGraphState,
});

export default setReportGraphState;
